import { getUser, User } from "./user";
import { getCountryCodeCookie } from "src/cookies";
import { setLocationPathname } from "src/navigation";
import { vendorCentralCountryConfig } from "./vendorCentralCountryConfig";
import { Page } from "./page";

export function getPagePath(page: Page): string {
  switch (page) {
    case Page.NEST:
      return "/inbound-central/nest";
    case Page.DISABLED:
      return "/inbound-central/disabled";
    case Page.AIC:
      return "/inbound-central";
  }
}

export function getAllowedPagesByCountryCode(countryCode: string): Page[] {
  return vendorCentralCountryConfig.get(countryCode)?.pages ?? [];
}

// Sort by path length descending so more specific paths match first
const pages = Object.values(Page)
  .map((page) => ({ page, path: getPagePath(page) }))
  .sort((a, b) => b.path.length - a.path.length);

export const getCurrentPage = (): Page | undefined => {
  const pathname = window.location.pathname;
  for (const { page, path } of pages) {
    if (pathname.startsWith(path)) return page;
  }
  return undefined;
};

export function isPageAllowed(page: Page | undefined): boolean {
  if (page === undefined || page === Page.DISABLED) {
    return true;
  }

  return getPagesAllowed().includes(page);
}

export function getPagesAllowed(): Page[] {
  switch (getUser()) {
    case User.PAYEE: {
      return [Page.NEST];
    }
    case User.STANDALONE: {
      return Object.values(Page);
    }
    case User.VENDORCENTRAL: {
      const countryCode = getCountryCodeCookie();
      if (countryCode === undefined) {
        return Object.values(Page);
      }
      return getAllowedPagesByCountryCode(countryCode);
    }
  }
}

export function redirectToAllowedPage(): void {
  const page = getCurrentPage();
  if (!isPageAllowed(page)) {
    const allowedPages = [...getPagesAllowed(), Page.DISABLED];
    setLocationPathname(getPagePath(allowedPages[0]));
  }
}
